import * as React from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import CardActions from "@mui/material/CardActions";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { MdCancel, MdNorthEast } from "react-icons/md";
import { BsQuestionCircle } from "react-icons/bs";
import * as CONST from "../../Constants";

const propTypes = {
  window: PropTypes.func,
  cpr: PropTypes.object.isRequired,
  children: PropTypes.object,
  reward: PropTypes.object,
  promptHandler: PropTypes.func.isRequired,
};
CprActions.prototype = propTypes;

export default function CprActions(props) {
  const history = useHistory();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [content, setContent] = React.useState(null);

  const [popoverAnchorEl, setPopoverAnchorEl] = React.useState(null);

  const handleClick = (event, content) => {
    setPopoverAnchorEl(event.currentTarget);
    console.log(content);
    setContent(content);
  };

  const handleClose = () => {
    setPopoverAnchorEl(null);
    setContent(null);
  };

  const open = Boolean(popoverAnchorEl);

  React.useEffect(() => {}, [props.cpr]);
  const isMenuOpen = Boolean(anchorEl);
  const handleCprMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const menuId = "cpr-actions-menu";
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      name: !props.cpr.appointment_date ? CONST.ADD_APPOINTMENT : CONST.EDIT_APPOINTMENT,
      disabled: props.cpr.status == "closed" || props.cpr.extensionsMaxed ? true : false,
      key: "scheduled",
      tooltip: CONST.TOOLTIP.ADD_APPOINTMENT_DETAILS,
    },
    {
      name: CONST.REPORT_AS_COMPLETED,
      key: "completed",
      disabled:
        props.cpr.status == "closed" || (props.cpr.document && props.cpr.document.url)
          ? true
          : false,
      tooltip: CONST.TOOLTIP.REPORT_AS_COMPLETED,
    },
    {
      name: CONST.ASK_A_QUESTION,
      key: "message",
      disabled: props.cpr.status == "closed",
      tooltip: CONST.TOOLTIP.ASK_A_QUESTION,
    },
    {
      name: CONST.REQUEST_ORDER_REFERRAL,
      key: "order",
      disabled:
        props.cpr.order_not_available_reason != null ||
        props.cpr.appointment_date ||
        props.cpr.status == "closed" ||
        props.cpr.patient_requested_order ||
        props.cpr.primary_code ||
        (props.cpr.order_document && props.cpr.order_document.url)
          ? true
          : false,
      tooltip: CONST.TOOLTIP.REQUEST_AN_ORDER,
    },
  ];

  const renderButtons =
    props.cpr.status == "closed" ? null : !props.cpr.needs_attention &&
      !location.pathname.includes("notifications") ? (
      <IconButton
        aria-controls={menuId}
        disabled={props.cpr.outcome_message ? true : false}
        sx={{ marginLeft: "auto" }}
        aria-haspopup="true"
        onClick={handleCprMenuOpen}
        className="card-button cpr-actions-button"
        aria-label="cpr actions"
      >
        {CONST.MORE_ACTIONS}
      </IconButton>
    ) : (
      !location.pathname.includes("notifications") && (
        <IconButton
          onClick={(e) => history.push(`/patient_portal/notifications/${props.cpr.id}`)}
          sx={{ marginLeft: "auto" }}
          className="card-button"
          aria-label="go to notification"
        >
          <MdNorthEast />
        </IconButton>
      )
    );

  return (
    <React.Fragment>
      <Popover
        open={open}
        anchorEl={popoverAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography variant="body1" sx={{ p: 2, maxWidth: 400 }}>
          {content}
        </Typography>
      </Popover>

      <CardActions className={!location.pathname.includes("notifications") ? "bb" : null}>
        {!props.reward && renderButtons}
        {props.reward && (
          <>
            {props.reward}
            {props.cpr.status == "closed" ? null : !props.cpr.needs_attention &&
              !location.pathname.includes("notifications") ? (
              <IconButton
                aria-controls={menuId}
                size="large"
                disabled={
                  props.cpr.outcome_message && !props.cpr.acknowledgedAfterOutcome ? true : false
                }
                sx={{ ml: "auto" }}
                aria-haspopup="true"
                onClick={handleCprMenuOpen}
                className="card-button hamburger-btn"
                aria-label="cpr actions"
              >
                {CONST.MORE_ACTIONS}
              </IconButton>
            ) : (
              !location.pathname.includes("notifications") && (
                <IconButton
                  onClick={(e) => history.push(`/patient_portal/notifications/${props.cpr.id}`)}
                  sx={{ marginLeft: "auto" }}
                  size="large"
                  className="card-button hamburger-btn"
                  aria-label="go to notification"
                >
                  <MdNorthEast />
                </IconButton>
              )
            )}
          </>
        )}
      </CardActions>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id={menuId}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        p={0}
      >
        <ListSubheader>
          <Box bgcolor="#1e2782" pl={2} sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="overline" color="#ffff">
              {CONST.MORE_ACTIONS}
            </Typography>
            <IconButton
              className="card-button close"
              aria-label="close more actions menu"
              onClick={(e) => handleMenuClose()}
              sx={{ mr: 0.5, ml: "auto" }}
            >
              <MdCancel />
            </IconButton>
          </Box>
        </ListSubheader>
        <Divider />
        {menuItems.map((i) =>
          i.disabled ? (
            <MenuItem disabled key={i.name}>
              <Typography variant="menu" py={0.75}>
                {i.name}
              </Typography>

              <IconButton
                sx={{ ml: 1 }}
                className="tooltip-button"
                aria-label={i.name + " tooltip"}
                onClick={(e) => handleClick(e, i.tooltip)}
              >
                <BsQuestionCircle />
              </IconButton>
            </MenuItem>
          ) : (
            <MenuItem key={i.name}>
              <Box
                onClick={(e) => {
                  e.preventDefault();
                  props.promptHandler(i.key);
                  handleMenuClose();
                }}
              >
                <Typography variant="menu" py={0.75}>
                  {i.name}
                </Typography>
              </Box>

              <IconButton
                sx={{ ml: 1 }}
                className="tooltip-button"
                aria-label={i.name + " tooltip"}
                onClick={(e) => handleClick(e, i.tooltip)}
              >
                <BsQuestionCircle />
              </IconButton>
            </MenuItem>
          )
        )}
      </Menu>
    </React.Fragment>
  );
}
